import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { publicationRightsStore } from '../../store/NonLinear/PublicationRightsStore';
import ModalDialogError from '../Controls/ModalDialogError';
import { LoadingBar } from '../Controls/LoadingBar';
import { YesNoRadioButtons } from '../Controls/YesNoRadioButtons';
import { SVMDatePicker } from '../Controls/SVMDatePicker';
import { EditableTextBox } from '../Controls/EditableTextBox';
import { getMandatoryBgCss, getStyleVisibility } from '../../tools/toolkit';

class PublicationRights extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            expiryDatePRIsMandatory: null
        };

        this.handleGlobalChanged = this.handleGlobalChanged.bind(this);
        this.handlePerpetuityChanged = this.handlePerpetuityChanged.bind(this);
        this.handleExpirySave = this.handleExpirySave.bind(this);
        this.handleRestrictionsSave = this.handleRestrictionsSave.bind(this);
    }

    handleErrorDialogClose = () => {
        this.props.clearErrorMessage();
    }

    handleGlobalChanged(isGlobal) {
        this.props.updateGlobal(this.props.programmeId, isGlobal);
    }

    handlePerpetuityChanged(inPerpetuity) {

        const mandatory = inPerpetuity === 'false';

        this.refs.expiryDateMandatory.style.visibility = getStyleVisibility(mandatory);

        if (this.state.expiryDatePRIsMandatory !== mandatory) {
            this.setState({
                expiryDatePRIsMandatory: mandatory
            })
        }

        this.props.updatePerpetuity(this.props.programmeId, inPerpetuity);
    }

    handleTerritoryChanged(event, territory) {
        this.props.updateTerritory(this.props.programmeId, territory, event.target.checked);
    }

    handleExpirySave(date) {
        this.props.updateExpiry(this.props.programmeId, date);
    }

    handleRestrictionsSave(value) {
        this.props.updateRestrictions(this.props.programmeId, value);
    }

    getTerritoryDisabled() {
        if (this.props.data.global === null || this.props.data.global === undefined || !(this.props.canEdit && !this.props.data.global)) {
            return true;
        }

        return false;
    }

    componentDidMount() {
        if (this.state.expiryDatePRIsMandatory === null && this.props.data) {
            this.setState({
                expiryDatePRIsMandatory: !this.props.data.inPerpetuity
            })
        }

        this.setAttributesForAccessibility();
    }

    componentDidUpdate() {
        if (this.state.expiryDatePRIsMandatory === null && this.props.data) {
            this.setState({
                expiryDatePRIsMandatory: !this.props.data.inPerpetuity
            })
        }

        this.setAttributesForAccessibility();
    }

    setAttributesForAccessibility() {
        const control = document.getElementById('expiryDatePR');

        if (control) {
            if (this.state.expiryDatePRIsMandatory) {
                control.setAttribute('aria-required', 'true');
            }
            else {
                control.setAttribute('aria-required', 'false');
            }

            this.refs.expiryDateMandatory.style.visibility = getStyleVisibility(this.state.expiryDatePRIsMandatory);
        }
    }

    renderTerritories() {
        if (!this.props.isLoading && this.props.data.rightsTerritories) {
            return (
                this.props.data.rightsTerritories.map(item =>
                    <div className='col-md-3'>
                        <label className='checkBoxLabel pr-2'>
                            <input
                                id={`territoriy${item.countryCode}checkbox`}
                                name={`territoriy${item.countryCode}checkbox`}
                                className='mr-1'
                                type="checkbox"
                                defaultValue="false"
                                defaultChecked={item.blocked}
                                onChange={(event) => this.handleTerritoryChanged(event, item.countryCode)}
                                disabled={this.getTerritoryDisabled()}
                                aria-label={item.name} />
                            {item.name}
                        </label>
                    </div>
                )
            );
        }

        return '';
    }

    render() {
        if (this.props.data) {
            return (
                <div className='publicationRightsBody'>
                    <div className='container-fluid pt-4'>
                        <div className='row bottomHorizontalRule mb-1'>
                            <h2 className='h2tablecell'>Content Rights</h2>
                        </div>
                        <div className='pl-2 pr-2'>
                            <div className='row'>
                                <div className='col-md-2 pl-0'>
                                    <label className='form-text'>Global rights obtained?</label>
                                </div>
                                <div className='col-md-10 pt-1 pl-0'>
                                    <YesNoRadioButtons
                                        id='globalRadioBtn'
                                        value={this.props.data.global}
                                        onClick={this.handleGlobalChanged}
                                        canEdit={this.props.canEdit}
                                        legend='Global rights are obtained' />
                                </div>
                            </div>
                            <div className='row' style={{ height: '200px' }}>
                                <div className='col-md-2 pl-0'>
                                    <label id="geoBlockedTerritoriesGroupLabel" className='form-text'>Geo-blocked territories<span className='mandatory' aria-hidden='true' style={{ visibility: getStyleVisibility(this.props.data.global === null ? false : !this.props.data.global) }} > *</span></label>
                                </div>
                                <div className='col-md-10 pl-0 pr-0'>
                                    <div
                                        role="group"
                                        aria-labelledby="geoBlockedTerritoriesGroupLabel"
                                        className={'row geoBlockedTerritories ' + getMandatoryBgCss(this.props.validationResult, 'geo_blocked_territories', 'geo_blocked')}
                                        aria-label='Selecting at lease one territory is mandatory'
                                        tabindex="0">
                                        {this.renderTerritories()}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-2 pl-0'>
                                    <label id='perpetuityLabel' className='form-text'>Available in perpetuity?</label>
                                </div>
                                <div className='col-md-10 pt-1 pl-0'>
                                    <YesNoRadioButtons
                                        id='perpetuityRadioBtn'
                                        value={this.props.data.inPerpetuity}
                                        onClick={this.handlePerpetuityChanged}
                                        canEdit={this.props.canEdit}
                                        legend='Rights are available in perpetuity' />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-2 pl-0'>
                                    <label className='form-text'>Expiry Date<span ref='expiryDateMandatory' className='mandatory' aria-hidden='true' style={{ visibility: getStyleVisibility(this.props.data.inPerpetuity === null ? false : !this.props.data.inPerpetuity) }}> *</span></label>
                                </div>
                                <div className='col-md-10 pt-1 pl-0'>
                                    <SVMDatePicker
                                        id='expiryDatePR'
                                        name='expiry'
                                        value={this.props.data.expiry}
                                        isEditable='true'
                                        onSaveClick={this.handleExpirySave}
                                        canEdit={this.props.canEdit}
                                        className={' ' + getMandatoryBgCss(this.props.validationResult, 'content_rights', 'expiry_date')}
                                        dateWarningMessage='Expiry Date'
                                        ariaLabel='Rights Expiry Date'
                                        onValidationError={(messages) => this.props.onValidationError(messages)} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-2 pl-0'>
                                    <label className='form-text'>Restrictions</label>
                                </div>
                                <div className='col-md-10 pt-1 pl-0 pr-0'>
                                    <EditableTextBox id='restrictionsTxt' name='restrictions' className='w-100' value={this.props.data.restrictions} cols='40' rows='5' maxLength='4000' onSaveClick={this.handleRestrictionsSave} canEdit={this.props.canEdit} ariaLabel='Rights restrictions' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalDialogError id='errorModalDialogPR' errorData={this.props.errorData} onCloseClick={this.handleErrorDialogClose} hasErrorOccured={this.props.hasErrorOccured} />
                    <LoadingBar isLoading={this.props.isLoading} />
                </div>
            );
        }

        return '';
    }
}

export default connect(
    state => state.publicationRights,
    dispatch => bindActionCreators(publicationRightsStore, dispatch)
)(PublicationRights);



// WEBPACK FOOTER //
// ./src/components/NonLinear/PublicationRights.js